import { Box } from '@material-ui/core'
import React from 'react'
import { AiOutlineCheckCircle } from 'react-icons/ai'
import { GiCancel } from 'react-icons/gi'

export default function ActionIcons({ approve, reject, display }) {
  console.log({ display })
  return (
    <Box display="flex" justifyContent="space-evenly">
      <AiOutlineCheckCircle style={{ color: 'green', fontSize: '20px', cursor: 'pointer' }} onClick={approve} />
      <GiCancel style={{ color: 'red', fontSize: '20px', cursor: 'pointer' }} onClick={reject} />
    </Box>
  )
}
